import React from 'react';
import {
  normalizePipelineStatus,
  getNextPipelineStatus,
  getPrevPipelineStatus,
  getPipelineStepLabel,
  pipelineRequiresApprovalPin,
  saleListingNeedsRaisingApproval,
} from '../../utils/submissions';

const SubmissionPipelineControls = ({ sub, onAdvance, onReject, onRequestApprovePin, pipelineBusy, addToast }) => {
  const status = normalizePipelineStatus(sub.status);
  const nextKey = getNextPipelineStatus(status);
  const prevKey = getPrevPipelineStatus(status);
  const nextLabel = nextKey ? `Send to ${getPipelineStepLabel(nextKey)}` : null;
  const prevLabel = prevKey ? `Back to ${getPipelineStepLabel(prevKey)}` : null;
  const needsRaisingApproval = saleListingNeedsRaisingApproval(sub);

  const handleNext = async () => {
    if (pipelineBusy || !nextKey) return;
    if (nextKey === "live" && needsRaisingApproval) {
      addToast?.(
        "Approve the share structure below (Save & approve) before moving this listing Live on Site.",
        "error"
      );
      return;
    }
    if (pipelineRequiresApprovalPin(status, nextKey)) {
      onRequestApprovePin(sub.id, nextKey);
      return;
    }
    await onAdvance(sub.id, nextKey);
  };

  const handlePrev = async () => {
    if (pipelineBusy || !prevKey) return;
    await onAdvance(sub.id, prevKey);
  };

  if (status === "rejected") {
    return (
      <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
        <button type="button" className="btn btn-outline btn-sm" onClick={() => onAdvance(sub.id, "listed")}>
          Restore to Listed
        </button>
      </div>
    );
  }

  return (
    <div className="admin-pipeline-controls__actions">
      {prevLabel && (
        <button type="button" className="btn btn-outline btn-sm" disabled={pipelineBusy} onClick={handlePrev}>
          <i className={`fas fa-arrow-left${pipelineBusy ? " fa-spinner fa-spin" : ""}`}></i> {prevLabel}
        </button>
      )}
      {nextLabel && (
        <button type="button" className="btn btn-primary btn-sm" disabled={pipelineBusy} onClick={handleNext}>
          {pipelineBusy ? "Updating…" : nextLabel} {!pipelineBusy && <i className="fas fa-arrow-right"></i>}
        </button>
      )}
      {!nextLabel && status === "live" && (
        <span style={{ color: "var(--success)", fontWeight: 600, fontSize: "0.9rem" }}>
          <i className="fas fa-check-circle"></i> Live on site
        </span>
      )}
      <button type="button" className="btn btn-ghost btn-sm" style={{ color: "var(--danger)" }} onClick={() => onReject(sub.id)}>
        Reject listing
      </button>
    </div>
  );
};

export default SubmissionPipelineControls;
